// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import 'third/jquery.slick.js';

export default class Webslider extends WebComponent {
	didMount() {
		$(this.element).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			variableWidth: false,
			autoplay: true,
			dots: true,
			arrows: false,
			infinite: true,
			speed: 3000,
			fade: true,
			cssEase: 'linear',
		});
	}
}




// WEBPACK FOOTER //
// ./fe/web-eshop/src/js/components/Webslider.js